import { AUTOMATION_PLATFORM_FLOW_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const AutomationPlatformFlow = ObjectDefinitionRecord({
  hasAccess: () => true,
  objectTypeId: AUTOMATION_PLATFORM_FLOW_TYPE_ID,
  referenceObjectType: 'AUTOMATION_PLATFORM_FLOW_PROPERTIES'
});
export default AutomationPlatformFlow;